module.exports = __webpack_public_path__ + "static/media/t18.57c18aaf.jpg";